

<template>
  <div class="page3">
     <div class="h90"></div>
     <div class="content">
        <div class="title1" :class="{'ani_right': ani_right}">{{msg}}</div>
        <div class="iCloud">
            I     
            <img class="pulse" :src="url + '/assets/icon-love.png'">
             DESIGN
        </div>
        <div class="title2">创造一流的用户体验，严谨的系统建设方案</div>
     </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
  name: "page3",
  data() {
    return {
        url: defaultSettings.url,
        msg: ''
    }
  },
   props:{
    ani_right: {
        type: [Boolean],
        require: false,
        default: false,
    },
  },
  watch: {
    ani_right (value) {
        if (value) {
            return this.msg = '注重用户体验，凸显高端设计'
        } else {
            this.msg = ''
        }
    }
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.page3 {
    margin:0 auto;
    text-align: right;
    .h90{
      height:90px;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .title1{
            height:100px;
            margin-top:28vh;
            font-size: 50px;
            font-weight: bold;
            color: #fff;
        }
        .title2{       
            font-size: 28px;
            font-weight: 300;
            color: #ffffffe6;
            margin-top:30px;
        }
        .iCloud{
            margin-top:45px;
            font-size: 80px;    
            font-family: DIN;
            color:#fff;   
            font-weight: 500;
            img{
                width:40px;
                height:34px;
                vertical-align: middle;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page3.vue